import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { segmentTrack } from 'src/app/state/actions';
import { fetchMedicationGuideForNDC } from 'src/app/state/actions/medicationGuides';
import { getCurrentMedicationGuideHtml, getHasMedicationGuidesLoaded, getNDCPathParam } from 'src/app/state/selectors';
import type { Dispatch } from 'src/app/state/store';

import { BrandedMedicationGuideRenderer } from '.';

const makeMapStateToProps = () => {
  const mapStateToProps = createStructuredSelector({
    ndc: getNDCPathParam,
    sanitizedMedGuideHtml: getCurrentMedicationGuideHtml,
    hasMedicationGuidesLoaded: getHasMedicationGuidesLoaded,
  });
  return mapStateToProps;
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchFetchMedicationGuides: (ndc: string) => dispatch(fetchMedicationGuideForNDC(ndc)),
  dispatchSegmentTrack: (event: UnifiedEvent, payload: any) => dispatch(segmentTrack(event, payload)),
});

const connector = connect(makeMapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const BrandedMedicationGuide = connector(BrandedMedicationGuideRenderer);
